import { Box, Button, ButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectApplicant } from "../../applicant/ApplicantSlice";
import { ApplicantViewDto } from "../../applicant/Models";
import ApplicantAssessementHistory from "./ApplicantAssessementHistory";
import EmailHistory from "./EmailHistory";
import StatusUpdateHistory from "./StatusUpdateHistory";

export default function ApplicantAudits() {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = useState<ApplicantViewDto>();
  const [audit, setAudit] = useState<number>(0);

  useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);

  const renderContents = () => {
    switch (audit) {
      case 0:
        return <StatusUpdateHistory applicant={data} />;
      case 1:
        return <ApplicantAssessementHistory applicant={data} />;
      case 2:
        return <EmailHistory applicant={data} />;
      default:
        break;
    }
  };

  return (
    <Box p={2}>
      <ButtonGroup
        size="small"
        disableElevation
        variant="outlined"
        aria-label="Disabled button group"
        sx={{ marginTop: -2, marginLeft: -3 }}
      >
        <Button
          onClick={() => setAudit(0)}
          disabled={audit === 0}
          className={`${audit === 0 && "selectedHistory"}`}
        >
          Status Update History
        </Button>
        <Button
          onClick={() => setAudit(1)}
          disabled={audit === 1}
          className={`${audit === 1 && "selectedHistory"}`}
        >
          Assessement History
        </Button>
        <Button
          onClick={() => setAudit(2)}
          disabled={audit === 2}
          className={`${audit === 2 && "selectedHistory"}`}
        >
          Email History
        </Button>
      </ButtonGroup>

      {renderContents()}
    </Box>
  );
}
